<h1 class="sub-header-1" [innerHtml]="referenceDataLabels.CreateCaseTitle | localizeLabel"></h1>
<p [innerHtml]="referenceDataLabels.CreateCaseDescription | localizeLabel"></p>

<div class="applicants-range">
    <p class="applicants-range-label" [innerHtml]="referenceDataLabels.NumberOfApplicantsId | localizeLabel"></p>
    <div *ngFor="let numberOfApplicants of numberOfApplicantsRange"
        (click)="selectNumberOfApplicants(numberOfApplicants)"
        class="applicant-range {{'kfi-people-' + numberOfApplicants}}"
        [ngClass]="{'selected-applicants-range': numberOfApplicants === caseSetup.NumberOfApplicants}">
    </div>
</div>

<h2 class="sub-header-2" [innerHtml]="referenceDataLabels.AboutMainApplicantId | localizeLabel"></h2>
<div class="dots-separator no-top-space"></div>

<div class="error-message mb-12" *ngIf="foreName.errors?.pattern"
    [innerHtml]="referenceDataConstants.ERROR_MESSAGE_AE000 | localizeErrorMessage: 'Forename' : ['Forename', caseSetup.Forename,'30']">
</div>
<boi-text-input name="caseSetupForename" [labelName]="referenceDataLabels.FirstNameAsPerId" [required]="true"
    [isTooltipLast]="true" [(ngModel)]="caseSetup.Forename" (ngModelChange)="formValueChanged()" #foreName="ngModel"
    [pattern]="namePattern">
</boi-text-input>

<div class="error-message mb-12" *ngIf="surname.errors?.pattern"
    [innerHtml]="referenceDataConstants.ERROR_MESSAGE_AE000 | localizeErrorMessage: 'Surname' : ['Surname', caseSetup.Surname,'30']">
</div>
<boi-text-input name="caseSetupSurname" [labelName]="referenceDataLabels.LastName" [required]="true"
    [showTooltip]="false" [(ngModel)]="caseSetup.Surname" (ngModelChange)="formValueChanged()" #surname="ngModel"
    [pattern]="namePattern">
</boi-text-input>

<h2 class="sub-header-2" [innerHtml]="referenceDataLabels.AboutTheMortgageId | localizeLabel"></h2>
<div class="dots-separator no-top-space"></div>

<boi-radio-button-group [labelName]="referenceDataLabels.IsRemortgageId" [required]="true"
    [(ngModel)]="caseSetup.IsRemortgage" (ngModelChange)="formValueChanged()"
    [optionList]="referenceDataOptionLists.PurchaseOrRemortgage"
    [cssClasses]="'label-left label-weight-bold label-font-size-13 row-options green-radio'">
</boi-radio-button-group>

<div *ngIf="caseSetup.IsRemortgage === referenceDataOptionLists.PurchaseOrRemortgageRemortgage" class="info-warning"
    [innerHtml]="referenceDataLabels.CompleteMortgageHolder | localizeLabel"></div>

<boi-drop-down [(ngModel)]="caseSetup.PropertyLocation" (ngModelChange)="formValueChanged()" [required]="true"
    [optionList]="referenceDataOptionLists.PropertyLocation" [showTooltip]="false"
    [labelName]="referenceDataLabels.WhereIsThePropertyYouAreMortgaId">
</boi-drop-down>

<div class="dots-separator"></div>

<boi-drop-down [labelName]="referenceDataLabels.WhereDidUserHearAboutProduct" [required]="true" [showTooltip]="false"
    [availableOptions]="whereDidUserHearAboutUsOptions" [valueField]="'ID'" [textField]="'Value'"
    [(ngModel)]="caseSetup.WhereDidUserHearAboutProduct" (ngModelChange)="formValueChanged()"></boi-drop-down>